import { useEffect } from "react";
import { intervalToDuration } from "date-fns";
import { SelectionDemandeResult } from "./models/selectionDemandeResult";

export enum TypeRecherche {
  Particulier = "particulier",
  Societe = "societe",
}

const KEY_STORAGE_DATE_UPDATE = "date_update";
export const KEY_STORAGE_DEMANDES = "demandes_deblocage";

export function getLastUpdate(): Date | undefined {
  const dateRaw = sessionStorage.getItem(KEY_STORAGE_DATE_UPDATE);
  return dateRaw ? new Date(dateRaw) : undefined;
}

export function setLastUpdate(date: Date = new Date()) {
  sessionStorage.setItem(KEY_STORAGE_DATE_UPDATE, String(date));
}
export function removeDateUpdate() {
  return sessionStorage.removeItem(KEY_STORAGE_DATE_UPDATE);
}

export function getDemandesDeblocage() {
  const demandesRaw = sessionStorage.getItem(KEY_STORAGE_DEMANDES);
  return demandesRaw ? JSON.parse(demandesRaw) : null;
}

export function setDemandesDeblocage(demandes: SelectionDemandeResult) {
  sessionStorage.setItem(KEY_STORAGE_DEMANDES,  JSON.stringify(demandes));
}
export function removeDemandesDeblocage() {
  return sessionStorage.removeItem(KEY_STORAGE_DEMANDES);
}

export function protectSteps(step: "criteres" | "selectionDemande" | "selectionAuthent" | "saisieCode" | "resultatsDebloques") {
  switch (step) {
    case "criteres": {
      break;
    }

    // case "resultats": {
    //   if (!resultats?.length) {
    //     const search = window.location.search;
    //     throw redirect(`/recherche-ri-hors-parc/vehicules${search}`);
    //   }
    //   break;
    // }

    // case "souscripteur": {
    //   if (resultats?.length > 0) {
    //     removeResultats();
    //   }
    //   break;
    // }
    default:
      break;
  }
}

export function useResetWorkflow(hoursToResetForm = 24) {
  useEffect(() => {
    const lastUpdate = getLastUpdate();
    if (!lastUpdate) return;
    const duration = intervalToDuration({ start: lastUpdate, end: Date.now() });
    if (Number(duration?.hours) >= hoursToResetForm) {
      removeDemandesDeblocage();
    }
  }, [hoursToResetForm]);
}